/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApproveDeviceAuthBody
} from './model/approveDeviceAuthBody.js';

import type {
  DenyDeviceAuthBody
} from './model/denyDeviceAuthBody.js';

import type {
  GetDeviceAuthPending200
} from './model/getDeviceAuthPending200.js';

import type {
  GetDeviceAuthPendingParams
} from './model/getDeviceAuthPendingParams.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Approve a device sign-in and mint the personal API key it delivers.
 */
export const approveDeviceAuth = (
    approveDeviceAuthBody: ApproveDeviceAuthBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/device/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: approveDeviceAuthBody, signal
    },
      options);
    }




export const getApproveDeviceAuthMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeviceAuth>>, TError,{data: ApproveDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveDeviceAuth>>, TError,{data: ApproveDeviceAuthBody}, TContext> => {

const mutationKey = ['approveDeviceAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveDeviceAuth>>, {data: ApproveDeviceAuthBody}> = (props) => {
          const {data} = props ?? {};

          return  approveDeviceAuth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveDeviceAuthMutationResult = NonNullable<Awaited<ReturnType<typeof approveDeviceAuth>>>
    export type ApproveDeviceAuthMutationBody = ApproveDeviceAuthBody
    export type ApproveDeviceAuthMutationError = unknown

    /**
 * @summary Approve a device sign-in and mint the personal API key it delivers.
 */
export const useApproveDeviceAuth = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveDeviceAuth>>, TError,{data: ApproveDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof approveDeviceAuth>>,
        TError,
        {data: ApproveDeviceAuthBody},
        TContext
      > => {
      return useMutation(getApproveDeviceAuthMutationOptions(options));
    }
    /**
 * @summary Deny a pending device sign-in.
 */
export const denyDeviceAuth = (
    denyDeviceAuthBody: DenyDeviceAuthBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/device/deny`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: denyDeviceAuthBody, signal
    },
      options);
    }




export const getDenyDeviceAuthMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyDeviceAuth>>, TError,{data: DenyDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof denyDeviceAuth>>, TError,{data: DenyDeviceAuthBody}, TContext> => {

const mutationKey = ['denyDeviceAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof denyDeviceAuth>>, {data: DenyDeviceAuthBody}> = (props) => {
          const {data} = props ?? {};

          return  denyDeviceAuth(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DenyDeviceAuthMutationResult = NonNullable<Awaited<ReturnType<typeof denyDeviceAuth>>>
    export type DenyDeviceAuthMutationBody = DenyDeviceAuthBody
    export type DenyDeviceAuthMutationError = unknown

    /**
 * @summary Deny a pending device sign-in.
 */
export const useDenyDeviceAuth = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof denyDeviceAuth>>, TError,{data: DenyDeviceAuthBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof denyDeviceAuth>>,
        TError,
        {data: DenyDeviceAuthBody},
        TContext
      > => {
      return useMutation(getDenyDeviceAuthMutationOptions(options));
    }
    /**
 * @summary Look up a pending device sign-in by its user code.
 */
export const getDeviceAuthPending = (
    params: GetDeviceAuthPendingParams,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<GetDeviceAuthPending200>(
      {url: `/device/pending`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDeviceAuthPendingQueryKey = (params?: GetDeviceAuthPendingParams,) => {
    return [
    `/device/pending`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDeviceAuthPendingQueryOptions = <TData = Awaited<ReturnType<typeof getDeviceAuthPending>>, TError = unknown>(params: GetDeviceAuthPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceAuthPending>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeviceAuthPendingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeviceAuthPending>>> = ({ signal }) => getDeviceAuthPending(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeviceAuthPending>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDeviceAuthPendingQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceAuthPending>>>
export type GetDeviceAuthPendingQueryError = unknown


/**
 * @summary Look up a pending device sign-in by its user code.
 */

export function useGetDeviceAuthPending<TData = Awaited<ReturnType<typeof getDeviceAuthPending>>, TError = unknown>(
 params: GetDeviceAuthPendingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDeviceAuthPending>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDeviceAuthPendingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






